import CitySEOHead from "@/components/feature/CitySEOHead";
import FortSmithHeroSection from "./components/HeroSection";
import FortSmithStickyNav from "./components/StickyNav";
import FortSmithProcessingTimeSection from "./components/ProcessingTimeSection";
import FortSmithServicesSection from "./components/ServicesSection";
import FortSmithLocalAreaSection from "./components/LocalAreaSection";
import FortSmithTravelTimingSection from "./components/TravelTimingSection";
import FortSmithDestinationsSection from "./components/DestinationsSection";
import FortSmithTestimonialsSection from "./components/TestimonialsSection";
import FortSmithAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import FortSmithComparisonSection from "./components/ComparisonSection";
import FortSmithMistakesSection from "./components/MistakesSection";
import FortSmithHowItWorksSection from "./components/HowItWorksSection";
import FortSmithFAQSection, { faqs } from "./components/FAQSection";
import FortSmithHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import FortSmithFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesSchema = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
];

export default function FortSmithPage() {
  return (
    <>
      <CitySEOHead
        city="Fort Smith"
        state="Arkansas"
        stateAbbr="AR"
        route="/fort-smith"
        title="Emergency Passport Fort Smith, AR — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Fort Smith, AR — as fast as 24 hours. Serving Ebbing ANG Base military, UAFS students, and western Arkansas families. A+ BBB rated, registered State Dept. courier."
        geoPlacename="Fort Smith, Arkansas"
        geoPosition="35.3859;-94.3985"
        faqs={faqs}
        servicesSchema={servicesSchema}
        statePageName="Arkansas"
        statePageRoute="/states/arkansas"
      />
      <div className="font-sans">
        <FortSmithHeroSection />
        <FortSmithStickyNav />
        <FortSmithProcessingTimeSection />
        <FortSmithLocalAreaSection />
        <FortSmithServicesSection />
        <FortSmithTravelTimingSection />
        <FortSmithDestinationsSection />
        <FortSmithTestimonialsSection />
        <FortSmithAcceptanceFacilitiesSection />
        <FortSmithComparisonSection />
        <FortSmithMistakesSection />
        <FortSmithHowItWorksSection />
        <FortSmithFAQSection />
        <FortSmithHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/fort-smith" state="AR" />
        <FortSmithFinalCTA />
      </div>
    </>
  );
}